import { AfterContentInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService, LoggerService } from '@wz-services';

@Component({
  selector: 'wz-opinion-a',
  templateUrl: './opinion-a.component.html',
  styleUrls: ['./opinion-a.component.scss'],
  standalone: false,
})
export class OpinionAComponent implements OnInit, AfterContentInit {
  constructor(
    private loadingService: LoadingService,
    private route: ActivatedRoute,
    private router: Router,
    private loggerService: LoggerService,
  ) {}

  nom: string = '';
  prenom: string = '';
  mail: string = '';
  tel: string = '';
  lead: number = 0;

  loading: boolean = false;

  ngOnInit() {
    if (this.route.snapshot.queryParamMap.get('id')) {
      var a: any = this.route.snapshot.queryParamMap.get('id');
      var parametre = atob(a);
      var parametreSplit = parametre.split('#');
      this.lead = parseInt(parametreSplit[1]);
      this.nom = parametreSplit[2];
      this.prenom = parametreSplit[3];
      this.mail = parametreSplit[4];
      var telEsp = parametreSplit[5]; //mila alana espace
      var telSplit = telEsp.split(' ');
      var tempTel = '';
      for (var i = 0; i < telSplit.length; i++) {
        tempTel += telSplit[i];
      }
      this.tel = tempTel;
      
      // Déclaration de type pour window avec la propriété OaP
      (window as any).OaP = {
        CarrierId: 484,
        ProductTypeId: 3,
        UserLogin: '',
        ContactEmail: this.mail, //cs.email
        ContactFirstName: this.prenom, //cs_prenom
        ContactLastName: this.nom, //cs_nom
        ContactPhone: this.tel, //cs_telephone
        IsCarrierContactAccept: false,
        CarrierExternalId: '',
      };

      this.loggerService.log((window as any).OaP);

      var js: any = document.getElementById('OpinionAssurancesPlugin');
      var url = new URL(
        'https://d2x33sw8v4ayed.cloudfront.net/resource/js/plugin.js',
      );
      var domain = url.protocol + '//';
      if (url.host.indexOf('d2x33sw8v4ayed.cloudfront.net') != -1) {
        domain += 'www.opinion-assurances.fr';
      } else {
        if (url.port != '') domain += url.host;
        else domain += url.hostname;
      }

      var iframe: any = document.createElement('iframe');
      iframe.setAttribute(
        'src',
        domain +
          '/temoignage-assurance-plugin-' +
          new Date().getTime() +
          '.html?3a1aa2c00b6c2e4ad135791a845a5298',
      );
      iframe.setAttribute('id', '3a1aa2c00b6c2e4ad135791a845a5298');
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.style.border = 'none';
      iframe.style.marginTop = '1%';

      if (typeof (window as any).OaP != 'undefined') {
        iframe.onload = function () {
          // if (js.getAttribute('data-size-height') == '1') {
          (window as any).OaP.SizeHeight = js.getAttribute('data-size-height');
          // }
          iframe.contentWindow.postMessage(
            JSON.stringify((window as any).OaP),
            window.location.href.split('/')[2],
          );
        };
      }

      // if (js.getAttribute('data-size-height') == '1') {
      try {
        var em =  (window as any).addEventListener ? 'addEventListener' : 'attachEvent';
        (window as any)[em](
          em == 'attachEvent' ? 'onmessage' : 'message',
          (e: any) => {
            try {
              var data = JSON.parse(e.data);
              switch (data.action) {
                case 'sizeHeight':
                  iframe.style.height = data.value;
                  break;
              }
            } catch (e) {
              //
            }
          },
          false,
        );
      } catch (e) {
        //
      }
      // }

      var parentElement = js.parentElement;
      parentElement.replaceChild(iframe, js);

      // var p = 0;

      // iframe.addEventListener('load', function () {

      //   var inputPrice = iframe.contentDocument.getElementById( 'PriceLevel' );
      //   this.loggerService.log(inputPrice);
      //   inputPrice.addEventListener('change', function () {
      //     this.loggerService.log(this);
      //   });
      // });

      // this.prixT = p;
    } else {
      this.router.navigate(['/']);
    }
  }
  ngAfterContentInit() {
    this.loadingService.loadingSubject.next(false);
  }
}
